import { css } from "styled-components";
import { parseHexToRGB } from "../../../../utils";
import { theme } from "../theme/lexusTheme";

const darkShadowColor = parseHexToRGB(theme.colors.platinumDark).rgb;
const lightShadowColor = parseHexToRGB(theme.colors.platinumLight).rgb;

/**
 * Shadow is a utility component that adds a shadow effect to an element.
 * You can use `textShadow` for text elements, or `boxShadow` for block elements.
 * @example
 * export const Title = styled(Type.H2)`
 *   font-family: ${theme.fonts.regular};
 *   ${textShadow};
 * `;
 */

export const textShadow = css`
    text-shadow: 0.2rem 0.2rem 0.2rem rgba(${darkShadowColor}, 0.7);
`;

export const lightTextShadow = css`
    text-shadow: 0.2rem 0.2rem 0.2rem rgba(${lightShadowColor}, 0.7);
`;

export const boxShadow = css`
    box-shadow: 0 0.5rem 1rem rgba(${darkShadowColor}, 0.5);
`;
